import { Dispatch, ReactElement, SetStateAction } from "react"

import FormNavigation from "../../../formNavigation/formNavigation"

interface IBackNextButtonsProps {
    isFirstStep: boolean
    setCurrentStepIndex: Dispatch<SetStateAction<number>>
    onClickBackFirstStep?: () => void
    onClickNext: () => void
    disabled?: boolean
    nextDisabled?: boolean
    firstStepNameOverride?: string
}

/**
 * Renders back and next buttons for the form generator.
 */
const BackNextButtons = ({
    isFirstStep,
    setCurrentStepIndex,
    onClickBackFirstStep,
    onClickNext,
    disabled = false,
    nextDisabled = false,
    firstStepNameOverride = "Start Again",
}: IBackNextButtonsProps): ReactElement => {
    /** Called when user clicks back. If on first step, go back to select
     * LCT screen. Otherwise, go back to previous step. Same for all forms.
     */
    const onClickBack = (): void => {
        if (isFirstStep) {
            onClickBackFirstStep?.()
        } else {
            setCurrentStepIndex((prev) => prev - 1)
        }
    }

    return (
        <FormNavigation
            onClickBack={onClickBack}
            onClickNext={onClickNext}
            backText={isFirstStep ? firstStepNameOverride : "Back"}
            nextText="Next"
            nextDisabled={disabled || nextDisabled}
            backDisabled={disabled}
        />
    )
}

BackNextButtons.defaultProps = {
    onClickBackFirstStep: undefined,
    disabled: false,
    nextDisabled: false,
    firstStepNameOverride: "Start Again",
}

export default BackNextButtons
